module.exports = __webpack_public_path__ + "static/service-section01-img-626ce94763ddbd6616014a592e9e1611.png";